// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WWLU","rootNoMargin":"styles_rootNoMargin__1zfX5"};